import styled from 'styled-components';
import { rem } from 'polished';

interface IStyledAbout {
  theme: any;
}

export const StyledAbout = styled.div<IStyledAbout>`
  .header {
    margin-bottom: ${rem(`190px`)};
  }
  .team-subtitle {
    margin-bottom: ${rem(`42px`)};
  }
  .team-members {
    display: grid;
    grid-auto-columns: min-content;
    grid-auto-flow: dense;
    grid-gap: ${rem(`24px`)};
    align-items: center;
    margin-top: ${rem(`12px`)};
    grid-template-columns: repeat(2, 1fr);
    ${({ theme }) => theme.breakpoints.watch`
      grid-template-columns: repeat(1, 1fr);
    `}
    ${({ theme }) => theme.breakpoints.phone`
      grid-template-columns: repeat(2, 1fr);
      padding: 0 ${rem(`16px`)};
    `}
    ${({ theme }) => theme.breakpoints.tablet`
      grid-template-columns: repeat(3, 1fr);
    `}
    ${({ theme }) => theme.breakpoints.desktop`
      padding: 0;
    `}
  }
  .main-title {
    font-size: 3em;
    ${(props) => props.theme.breakpoints.phone`
      font-size: 4em;
    `}
  }
  .mobile-main {
    padding: ${rem(`16px`)} 0 0;
  }
  .mobile-content-welcome h2 {
    line-height: 3.5rem;
    word-break: break-word;
    ${({ theme }) => theme.breakpoints.phablet`
      word-break: initial;
    `}
  }
  .mobile-content-welcome,
  .mobile-content-cta,
  .mobile-content-social,
  .team-title,
  .team-subtitle {
    padding: 0 ${rem(`16px`)};
    ${({ theme }) => theme.breakpoints.desktop`
      padding: 0;
    `}
  }
  .back-button {
    margin-top: ${rem(`48px`)};
  }
`;
